<template>
  <rest-list-page :page-title="pageTitle" :fetch-endpoint="fetchEndpoint">
    <template slot="table">
      <rest-list-column
        prop="title"
        :title="$t('AppImpressions_Field_Title')"
      ></rest-list-column>

      <rest-list-column-actions v-if="!readonly">
        <template slot-scope="scope">
          <rest-list-action-delete :endpoint="rowDeleteEndpoint(scope.row)" />
        </template>
      </rest-list-column-actions>
    </template>
  </rest-list-page>
</template>

<script>
import RestListPage from '@/common/components/rest/RestListPage'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'ImpressionsListPage',

  components: {
    RestListPage,
    RestListColumn,
    RestListColumnActions,
    RestListActionDelete
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `impressions`,
        params: {}
      })
    },

    readonly() {
      return !this.$can('manageProjectTechnical')
    }
  },

  methods: {
    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `impressions/${row.id}`
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/impressions/pages/ImpressionsListPage.vue